import { ArticleView } from "@serophin/nottldr-shared";
import { ArticleList } from "../../components/article/ArticleList";
import { CategoryFilter } from "../../components/explore/CategoryFilter";
import type { PageProps } from "../pageProps";
import { type ArticleListSeed, SEED } from "./seedTypes";
import { EXPLORE_TABS, useHeaderTabs } from "./tabs";
import { filterOf, useCategoryFilter } from "./useCategoryFilter";
import { useSeed } from "./useSeed";
import { useSeededArticles } from "./useSeededArticles";

export const FILTER_CARD_CLASS = "mb-3 bg-white dark:bg-neutral-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden p-2";

/** Explore articles: every published article, newest first, narrowed by category and subcategory. */
export const ArticlesPage = (_props: PageProps) => {
  const seed = useSeed<ArticleListSeed>(SEED.articles);
  const selection = useCategoryFilter();
  const filterKey = `${selection.category}/${selection.subcategory}`;
  const list = useSeededArticles({ view: ArticleView.ALL, filter: filterOf(selection), filterKey, seed });
  useHeaderTabs(EXPLORE_TABS, "articles");

  return (
    <div>
      <div class={FILTER_CARD_CLASS}>
        <CategoryFilter
          selectedCategory={selection.category}
          selectedSubcategory={selection.subcategory}
          onCategoryChange={selection.selectCategory}
          onSubcategoryChange={selection.selectSubcategory}
        />
      </div>
      <ArticleList
        metas={list.metas}
        authors={list.authors}
        hasMore={list.hasMore}
        isLoading={list.isLoading}
        onLoadMore={list.loadMore}
        resetKey={filterKey}
      />
    </div>
  );
};
